import { Suspense } from 'react';
import { ErrorBoundary } from '~/components/Tools';

export type TErrorFallback = {
  error: Error;
  componentStack: string | null;
  resetError: () => void;
};

export type TErrorBoundary = {
  onError?: (error: Error) => void;
  errorFallback: (props: TErrorFallback) => JSX.Element;
};

export type TSuspenseBoundary = {
  delayedFallback: () => JSX.Element;
};
export type TAsyncRendering = { children: React.ReactNode } & TErrorBoundary & TSuspenseBoundary;

function AsyncRendering({ children, onError, delayedFallback, errorFallback }: TAsyncRendering) {
  return (
    <ErrorBoundary fallback={errorFallback} onError={onError}>
      <Suspense fallback={delayedFallback()}>{children}</Suspense>
    </ErrorBoundary>
  );
}

export default AsyncRendering;
